
export enum ReasonCode {
    CameraEvent = -2,
    ErrorGeneric = -1, // Legacy error
    Unknown = 0, // Unknown - perhaps we don't know how to decode this packet
    TravelPlot = 1,
    TravelPlot2 = 2,
    Sendloc = 3, // Standard location send, usually triggered by a request from a user
    GeofenceCrossing = 5, // Onboard geofence perimeter crossing
    Telematics = 6, // Input triggered high or low on device
    TravelStart = 7,
    TravelStop = 8,
    IgnitionOn = 9,
    IgnitionOff = 10,
    Wakeup = 13,
    OverSpeed = 14, // Legacy - Speeding triggered on device (threshold set on device)
    NormalSpeed = 15, // Legacy - Return to normal speed
    DirectionChange = 16,
    LogonStatus = 20,
    Temperature = 24,
    Fms = 36,
    FmsOn = 37,
    FmsOff = 38,
    Accelerometer = 42,
    Crash = 45,
    Alcolock = 48,
    Diagnostics = 49,
    PeripheralDisconnected = 50,
    TroubleCodes = 51, // DTC/Engine fault codes
    TyrePressures = 52,
    Speeding = 53,
    ContextualSpeeding = 54,
    HarshBraking = 55,
    HarshCornering = 56,
    HarshAcceleration = 57,
    Idling = 58, // This option is actually used for idling over threshold events, not raw idling
    EmergencyButton = 59,
    InputTrigger = 60,
    OverRpm = 61,
    HarshShock = 62,
    UnknownHarshEvent = 63,
    BadAnticipation = 65,
    FuelTheft = 66,
    IdlingOverLowThreshold = 68,
    IdlingOverMedThreshold = 69,
    IdlingOverHighThreshold = 70,
    CruiseOff = 71,
    CruiseOn = 72,
    PtoOff = 73,
    PtoOn = 74,
    TopGearStop = 75,
    TopGearStart = 76,
    TopGearCruisePotentialStart = 77,
    TopGearCruisePotentialStop = 78,
    EngineBrakeOn = 79,
    EngineBrakeOff = 80,
    PowerEvent = 81,
    Motion = 82,
    FridgeController = 83,
    IdlingEnd = 84, // This reason code is only used for supporting messages coming from old jpod configs as we transition to using reason codes, not sensor data
    TachoUpdate = 85,
    OverRpmEnd = 86,
    RolloverStabilityControl = 87,
    CameraVideoLoss = 88,
    CameraCovered = 89,
    MemoryFault = 90,
    LowVoltage = 91,
    PowerLoss = 92,
    GpsSignalLoss = 93,

    // ADAS/DMS
    BlindSpot = 200,
    LaneDeparture = 201,
    CollisionWarning = 202,
    VehicleTooClose = 203,
    DriverFatigue = 204,
    DriverAbsent = 205,
    DriverOnPhone = 206,
    DriverSmoking = 207,
    DriverDistraction = 208,
    DriverNoSeatBelt = 209,
    DriverYawn = 210
}
